import { createApp } from 'vue'
import App from './App.vue'
import './html/css/style.css'
import './html/js/script.js'

createApp(App).mount('#app')
